module.exports = __webpack_public_path__ + "media/iphone1.26725dfc.mp3";